import S from "./index.module.scss";
import { Container } from "@/components/ui/container";
import { NAVS } from "../../../../core/constants/navigation";
import Link from "next/link";
import { useEffect } from "react";

interface SidebarProps {
  onClose: () => void;
}

const Sidebar = ({ onClose }: SidebarProps) => {
  useEffect(() => {
    const scrollPosition = Math.max(window.scrollY, document.documentElement.scrollTop, document.body.scrollTop);
    const previousBodyStyles = {
      position: document.body.style.position,
      top: document.body.style.top,
      width: document.body.style.width,
      overflow: document.body.style.overflow,
    };
    const previousHtmlOverflow = document.documentElement.style.overflow;
    const previousScrollBehavior = document.documentElement.style.scrollBehavior;

    document.documentElement.style.overflow = "hidden";
    document.body.style.position = "fixed";
    document.body.style.top = `-${scrollPosition}px`;
    document.body.style.width = "100%";
    document.body.style.overflow = "hidden";

    return () => {
      document.documentElement.style.overflow = previousHtmlOverflow;
      document.documentElement.style.scrollBehavior = "auto";
      document.body.style.position = previousBodyStyles.position;
      document.body.style.top = previousBodyStyles.top;
      document.body.style.width = previousBodyStyles.width;
      document.body.style.overflow = previousBodyStyles.overflow;
      window.scrollTo(0, scrollPosition);
      document.documentElement.scrollTop = scrollPosition;
      document.body.scrollTop = scrollPosition;
      document.documentElement.style.scrollBehavior = previousScrollBehavior;
    };
  }, []);

  return (
    <div className={S.sidebarWrapper}>
      <Container>
        <div className={S.navWrapper}>
          {NAVS.map((nav, idx) => (
            <Link href={nav.href} key={idx} className={S.navLink} onClick={onClose}>
              {nav.title}
            </Link>
          ))}
        </div>
      </Container>
      <div className={S.sidebarEmailWrapper}>
        <Container>
          <a href="mailto:info@nesterenkowatches.com" className={S.sidebarEmail}>
            info@nesterenkowatches.com
          </a>
        </Container>
      </div>
    </div>
  );
};

export default Sidebar;
